import script from "./CommissionManage.vue?vue&type=script&setup=true&lang=js"
export * from "./CommissionManage.vue?vue&type=script&setup=true&lang=js"

import "./CommissionManage.vue?vue&type=style&index=0&id=7a52046e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a52046e"]])

export default __exports__